import Rails from "@rails/ujs"
// import Turbolinks from "turbolinks"
// import * as ActiveStorage from "@rails/activestorage"

const images = require.context('../src/admin/images', true)


import 'src/admin/stylesheets/admin'
import jquery from 'jquery'
import 'jquery-ui-sortable-npm'
import 'bootstrap'
import 'select2'
import 'select2/dist/css/select2'
import toastr from 'toastr'
import '@fortawesome/fontawesome-free/css/all'
import feather from 'feather-icons/dist/feather'
import 'src/admin/sidebar-menu'
import 'src/admin/script'
import 'themify-icons-sass/themify-icons/_themify-icons'
import Inputmask from 'inputmask'
import moment from 'moment'
import * as tempusDominus from 'src/admin/tempus-dominus'
import Dropzone from "dropzone"
import "@nathanvda/cocoon"

global.$ = global.jQuery = jQuery;
global.toastr = toastr;
global.inputmask = Inputmask;
global.moment = moment;
global.tempusDominus = tempusDominus;
global.Dropzone = Dropzone;

moment.locale('ru');

Rails.start()
// Turbolinks.start()
// ActiveStorage.start()

$(document).ready(function() {
  $(".clickable-row td:not(.nolink)").click(function() {
    window.location = $(this).closest('tr').data("href");
  });

  $(".mobile-toggle").click(function(){
    $(".nav-menus").toggleClass("open");
  });

  $('#q_reset').click(function(){
    $('.search-field').val('');

    $('select.search-field').each(function() {
      $(this).val(null);
      $(this).trigger('change');
    });
  });

  $('.full-screen').click(function() {
    if ((document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  });

  $('.select2-field').select2({allowClear: true});

  feather.replace();

  $('.loader-wrapper').fadeOut('slow', function() {
    $(this).remove();
  });

  $('.datetime-picker').each( function(index, value) {
    new tempusDominus.TempusDominus(this, {
      display: {
        components: {
          useTwentyfourHour: true
        }
      },
      hooks: {
        inputFormat: (context, date) => {
          return moment(date).format('DD.MM.YYYY LT')
        },
        inputParse: (context, value) => {
          return new tempusDominus.DateTime(moment(value, 'DD.MM.YYYY LT').toDate())
        }
      }
    })
  });

  $('.date-picker').each( function(index, value) {
    new tempusDominus.TempusDominus(this, {
      display: {
        components: {
          clock: false
        }
      },
      hooks: {
        inputFormat: (context, date) => {
          return moment(date).format('DD.MM.YYYY')
        },
        inputParse: (context, value) => {
          return new tempusDominus.DateTime(moment(value, 'DD.MM.YYYY').toDate())
        }
      }
    })
  });

  /*----------------------------------------
  password show hide
  ----------------------------------------*/
  $('.show-hide').show();
  $('.show-hide span').addClass('show');

  $('.show-hide span').click(function () {
  if ($(this).hasClass('show')) {
    $('input[name="user[password]"]').attr('type', 'text');
    $(this).removeClass('show');
  } else {
    $('input[name="user[password]"]').attr('type', 'password');
    $(this).addClass('show');
  }
  });
  $('form button[type="submit"]').on('click', function () {
  $('.show-hide span').addClass('show');
  $('.show-hide').parent().find('input[name="user[password]"]').attr('type', 'password');
  });

  $(".mode").on("click", function () {
    $('.mode i').toggleClass("fa-moon-o").toggleClass("fa-lightbulb-o");
    // $('.mode-sun').toggleClass("show")
    $('body').toggleClass("dark-only");
    var color = $(this).attr("data-attr");
    localStorage.setItem('body', 'dark-only');
  });
});